<template>
    <div class="flex flex-col items-center justify-between h-full">
        <div class="flex justify-center mb-2 h-full">
            <img
                class="inline-block h-32 rounded-2xl object-cover"
                :class="{ 'border border-gray-200': image }"
                :src="imageUrl ?? image"
                :alt="name"
            />
        </div>

        <div class="ml-4 flex">
            <div
                class="relative cursor-pointer bg-white py-2 px-3 border border-blue-gray-300 rounded-md shadow-sm flex items-center hover:bg-blue-gray-50 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-blue-gray-50 focus-within:ring-primary"
            >
                <label
                    :for="id"
                    class="relative text-sm font-medium text-blue-gray-900 cursor-pointer"
                >
                    Auswählen
                </label>
                <input
                    :id="id"
                    :name="id"
                    type="file"
                    @change="handleFileUpload"
                    accept="image/*"
                    class="absolute cursor-pointer inset-0 w-full h-full opacity-0 border-gray-300 rounded-md"
                />
            </div>
            <button
                @click="removeImage"
                type="button"
                class="ml-3 bg-transparent py-2 px-3 border border-transparent rounded-md text-sm font-medium text-blue-gray-900 hover:text-blue-gray-700 focus:outline-none focus:border-blue-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-gray-50 focus:ring-primary"
            >
                Löschen
            </button>
        </div>
    </div>
</template>
<script>
export default {
    emits: ["selected", "removed"],

    props: {
        name: {
            type: [String, null],
            required: true,
        },
        preselectedImage: {
            type: [String, File],
            required: false,
        },
    },

    data() {
        return {
            id: Math.floor(Math.random() * 100000),
            image: null,
            imageUrl: "/images/file-image.svg",
            inputElement: null,
        };
    },

    methods: {
        handleFileUpload() {
            if (!this.inputElement.files.length) {
                return;
            }
            this.image = this.inputElement.files[0];
            this.imageUrl = URL.createObjectURL(this.inputElement.files[0]);
            this.$emit("selected", this.image);
        },

        removeImage() {
            this.image = null;
            this.imageUrl = "/images/file-image.svg";
            this.$emit("removed", null);
        },

        async getPreselectedImage() {
            if (!this.preselectedImage) {
                return "/images/file-image.svg";
            }

            const response = await fetch(this.preselectedImage);
            const blob = await response.blob();
            const file = new File([blob], "image.jpg", { type: blob.type });

            this.image = file;
            this.imageUrl = URL.createObjectURL(file);

            this.$emit("selected", this.image);
        },
    },

    async mounted() {
        this.inputElement = document.getElementById(this.id);

        await this.getPreselectedImage();
    },
};
</script>
